import React from 'react';
import { Link } from 'react-router';
import { observer } from 'mobx-react-lite';
import { format } from 'date-fns';
import { ElevatedButton } from '@producer/ui-kit';
import styled from 'styled-components';

import { Space } from '../../../../app/entities';
import {
  Amount,
  PanelHeader,
  StorageProgress,
} from '../../../settings/components/storage-progress';
import { dateShort } from '../../../../assets/contants/dates-fns';
import { SeatsProgress } from '../../../settings/components/seats-progress';
import { Header } from './styled-billing';
import { SettingsSection } from './settings-section';

import styles from './settings-section.module.scss';
import { openModal } from '../../../../core/modal/open-modal';
import { PurchaseCreditsModal } from '../../../../routes/space/settings/purchase-credits.modal';

type StorageBillingSectionProps = {
  space: Space;
};

export const StorageBillingSection: React.FC<StorageBillingSectionProps> = observer(({ space }) => (
  <div className={styles['section']}>
    <HeaderWrapper>
      <Header>
        {space?.billingDetails?.nextRenewal && (
          <>
            <h3>{format(new Date(space.billingDetails.nextRenewal), dateShort)}</h3>

            <label>Next invoice date</label>
          </>
        )}
      </Header>

      {space.hasSubscription() && space.subscription?.provider === 'paddle' && (
        <Action to={'./history'}>View billing history</Action>
      )}
    </HeaderWrapper>

    <SettingsSection title="Storage">
      <StorageProgress space={space} />
    </SettingsSection>

    {space.flags.isAiAccessible && (
      <SettingsSection title="AI Credits">
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <PanelHeader>
              <label>Current credits</label>
            </PanelHeader>
            <Amount>{space.credits.current}</Amount>
          </div>

          <ElevatedButton
            text="Add credits"
            onClick={() => {
              openModal(PurchaseCreditsModal, {
                space,
              });
            }}
          />
        </div>
      </SettingsSection>
    )}

    {space.hasSubscription() && !space.isSelfServing && (
      <SettingsSection title="Seats">
        <SeatsProgress space={space} />
      </SettingsSection>
    )}
  </div>
));

const Action = styled(Link)`
  all: unset;
  color: var(--color-primary-crayola);
  font-size: 1.6rem;
  font-weight: 400;
  width: auto;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  padding-bottom: 1.6rem;
  border-bottom: 1px solid var(--color-grayscale-trout);
`;
